/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PcmsHubJuvenileDemographicProjection } from './pcms-hub-juvenile-demographic-projection';


export interface PcmsHubDemographicSnapshotRequest { 
    asOfDate: string;
    outcome: PcmsHubDemographicSnapshotRequest.OutcomeEnum;
    projection: PcmsHubJuvenileDemographicProjection;
}
export namespace PcmsHubDemographicSnapshotRequest {
    export const OutcomeEnum = {
        Current: 'CURRENT',
        Deleted: 'DELETED'
    } as const;
    export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];
}


